import React, { createContext, useContext, useState, useCallback } from 'react';
type ToastType = 'success' | 'error' | 'warning' | 'info';
interface Toast { id: number; message: string; type: ToastType; }
interface ToastContextType { showToast: (message: string, type?: ToastType) => void; }
const ToastContext = createContext<ToastContextType | null>(null);
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const showToast = useCallback((message: string, type: ToastType = 'success') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    const duration = type === 'error' ? 10000 : 3000;
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);
  const dismiss = (id: number) => setToasts(prev => prev.filter(t => t.id !== id));
  const copyText = (text: string) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };
  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className="toast-container">
        {toasts.map(toast => (
          <div key={toast.id} className={`toast toast-${toast.type}`} style={{ display:'flex', alignItems:'flex-start', gap:8, minWidth:280 }}>
            <span style={{ flex:1, fontSize:12 }}>{toast.message}</span>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              {toast.type === 'error' && (
                <button
                  onClick={() => copyText(toast.message)}
                  style={{ background:'rgba(255,255,255,0.2)', border:'none', color:'white', borderRadius:4, padding:'2px 6px', fontSize:10, cursor:'pointer', fontFamily:'inherit' }}
                  title="Copy error"
                >
                  Copy
                </button>
              )}
              <button
                onClick={() => dismiss(toast.id)}
                style={{ background:'rgba(255,255,255,0.2)', border:'none', color:'white', borderRadius:4, padding:'2px 6px', fontSize:12, cursor:'pointer', lineHeight:1 }}
              >
                ×
              </button>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
};
